<template>
  <v-container style="background-color: #f5f5f9; height: 100vh" fluid>
    <SidebarCompVue></SidebarCompVue>
    <main class="main-wrapper">
      <HeaderComp />
      <slot></slot>
    </main>
    <footer></footer>
  </v-container>
</template>

<script>
import SidebarCompVue from "@/components/elements/SidebarComp.vue";
import HeaderComp from "@/components/elements/HeaderComp.vue";

export default {
  components: { SidebarCompVue, HeaderComp },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  padding-left: 260px;
}
</style>
